import { BaseModel } from '..'

class Translations extends BaseModel {
    constructor(json, ...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'translations'
    }

    get(lang, version) {
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                this._client
                    .index(`${this.base}/${lang}/${version}`)
                    .then((res) => {
                        return resolve(res)
                    })
                    .catch((e) => {
                        return reject(e)
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }
}

export { Translations }
